import { useFormContext } from 'react-hook-form';
import { HookInput } from '@/components/UI/HookForm/Form/Input';
import useUpdateEffect from '@/hooks/useUpdateEffect';
import type { BudgetChangeOrderSchema } from '../BudgetForm/validationSchema';

export function ChangeInBudgetInput() {
  const formMethods = useFormContext<BudgetChangeOrderSchema>();
  const lineItem = formMethods.watch('lineItem');
  const proposedAmount = formMethods.watch('proposedAmount');

  useUpdateEffect(() => {
    if (lineItem?.amount) {
      const diffAmount = proposedAmount - lineItem.amount;

      formMethods.setValue('impact', diffAmount);
    } else {
      formMethods.setValue('impact', 0);
    }
  }, [lineItem, proposedAmount]);

  return <HookInput formMethods={formMethods} label='Change in Budgeted Amount' disabled type='number' name='impact' />;
}
